import React from 'react';
import PropTypes from 'prop-types';
import Parser from "html-react-parser";
import "./Checkboxes.scss";
import Image from "../../UI/Images/Image";

class Checkboxes extends React.Component {

  render() {

    const { checkboxes, onChangeCheckbox } = this.props;

    return (
      <div className={"checkboxes"}>
        {checkboxes.map((field, index) => {
          return (
            <div key={index}
                 className={"checkbox-box"}>
              <div className={`checkbox ${field.isActive ? "checked" : ""} ${field.hasError ? "has-error" : ""}`}>
                <Image src={`${process.env.PUBLIC_URL}/assets/images/svg/checkmark.svg`} />
                <input type={"checkbox"}
                       checked={field.isActive}
                       id={field.name}
                       name={field.name}
                       onChange={() => onChangeCheckbox(field)} />
              </div>
              <label htmlFor={field.name}>{Parser(field.label)}</label>
            </div>
          )
        })}
      </div>
    );

  }
}

Checkboxes.propTypes = {
  checkboxes: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Checkboxes;
